
export const capitalizeFirst=function(inText:string){
	if(inText.length===0)return inText;
	let outText=inText;
	return outText.charAt(0).toUpperCase()+outText.slice(1);
}
